import { render, staticRenderFns } from "./OptionalTeacher.vue?vue&type=template&id=36dac074"
import script from "./OptionalTeacher.vue?vue&type=script&lang=js"
export * from "./OptionalTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports